// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2kMxc","file":"styles_file__3NB9Z"};